import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import { UserProvider } from '#AdminPanelFrontend/contexts/UserContext';
import { SsoProvider } from '#AdminPanelFrontend/contexts/SsoContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<SsoProvider>
		<UserProvider>
			<App />
		</UserProvider>
	</SsoProvider>
);
